import {authServerInstance, gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const addStakeholderVehicleType = async (data) => {
    const response = await gatewayInstance.post(`${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type`, data);
    return response;
};

export const updateStakeholderVehicleType = async (data) => {
    const response = await gatewayInstance.put(`${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type`, data);
    return response;
};

export const searchStakeholderVehicleType = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
export const getStakeholderVehicleTypeByStkId = async (stkId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type/${stkId}`);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getStakeholderVehicleTypeByCustomerShipper = async (customerShipper) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type/customer-shipper/${customerShipper}`);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getStakeholderVehicleTypeByStvId = async (svtId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type/bySvtId/${svtId}`);
        console.log("api response",response)
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const findStakeholderVehicleType = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder-vehicle-type/active-stk-veh`,
            data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

